import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isBlank } from 'utils/isBlank';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import { useDataFetcherV2 } from 'components/Common/Data/useDataFetcher';
import { openPaywall } from 'components/Apps/AppDetails/Redux/Actions';
import useQuickbooksConnections from 'hooks/useQuickbooksConnections';
import EnableAppButton from 'components/QuickbooksOnline/App/EnableAppButton';
import {
  canUseAddJobs,
  fetchOrganizationFeatures,
  getQboFeature
} from 'resources/Organization/Features/FeaturesData';

const QboButton = () => {
  const dispatch = useDispatch();

  const [featuresFetched] = useDataFetcherV2(fetchOrganizationFeatures);

  const qboFeature = useSelector(getQboFeature)
  const canImport = useSelector(canUseAddJobs);

  const missingFeature = isBlank(qboFeature) || !canImport;

  const { qboConnected } = useQuickbooksConnections();

  if (featuresFetched && missingFeature) {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={() => dispatch(openPaywall())}
      >
        Upgrade
      </Button>
    );
  }

  if (featuresFetched && !qboConnected) {
    return <EnableAppButton />
  }

  return <></>;
};

export default QboButton;
